(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["_hover-subscription-block"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    // Cible le bloc d'info abonnement à masquer ou afficher
    const abonnementContainer = document.querySelector('.abonnement-container');

    // Handle radio button interactions for subscription block
    const subscriptionBlocks = document.querySelectorAll('.hv-subscription-block');

    // Met à jour l'état visuel des cartes et la visibilité du bloc abonnement
    function refreshStatesForBlock(block) {
      const options = block.querySelectorAll('.hv-subscription-option');

      options.forEach((option) => {
        const radioInput = option.querySelector('input[type="radio"]');

        if (radioInput && radioInput.checked) {
          option.classList.add('hv-subscription-option--active');
        } else {
          option.classList.remove('hv-subscription-option--active');
        }
      });

      // Si le bloc abonnement existe, on masque si "sans abonnement" est coché
      if (abonnementContainer) {
        const selected = block.querySelector('input[type="radio"]:checked');
        if (selected && selected.value === 'none') {
          abonnementContainer.style.display = 'none';
        } else {
          abonnementContainer.style.display = '';
        }
      }
    }

    subscriptionBlocks.forEach((block) => {
      const options = block.querySelectorAll('.hv-subscription-option');
      const radioInputs = block.querySelectorAll('input[type="radio"]');

      // Initialisation au chargement
      refreshStatesForBlock(block);

      radioInputs.forEach((input) => {
        input.addEventListener('change', function () {
          refreshStatesForBlock(block);
        });
      });

      // Clic sur toute la carte
      options.forEach((option) => {
        option.addEventListener('click', function (e) {
          if (e.target.type !== 'radio' && e.target.tagName !== 'LABEL') {
            const radioInput = this.querySelector('input[type="radio"]');
            if (radioInput) {
              radioInput.checked = true;
              radioInput.dispatchEvent(new Event('change'));
            }
          }
        });
      });
    });
  });

document.addEventListener('DOMContentLoaded', function () {
  const abonnementContainer = document.querySelector('.abonnement-container');
  if (!abonnementContainer) return;

  // On cible tous les radios des abonnements
  const radios = document.querySelectorAll('input[type="radio"][name^="subscription-"]');

  if (!radios.length) return;

  function updateAbonnementVisibility() {
    const selected = Array.from(radios).find(radio => radio.checked);
    if (!selected) return;

    if (selected.value === 'none') {
      // Sans abonnement
      abonnementContainer.style.display = 'none';
    } else {
      // Avec abonnement
      abonnementContainer.style.display = '';
    }
  }

  // Au changement de choix
  radios.forEach((radio) => {
    radio.addEventListener('change', updateAbonnementVisibility);
  });

  // Etat initial au chargement
  updateAbonnementVisibility();
});
  } catch(e) { console.error(e); }
})();

})();
